import React, { useState, useCallback, useMemo } from 'react';
import DMActionsModal from 'components/features/DMActionsModal/DMActionsModal';
import { ActionsIcon } from 'components/icons';
import styles from './BundleOverviewControllerDMActions.module.css';

const BundleOverviewControllerDMActions = ({ bundle, bundleMembers, isGa2, device, action }) => {
  const [isDMActionsModalOpen, setIsDMActionsModalOpen] = useState(false);

  const allDeviceIds = useMemo(() => {
    let newDeviceIds = [];
    if (bundle && bundle?.members?.length === bundleMembers?.length) {
      newDeviceIds = bundleMembers.map((member) => member.id);
    } else if (isGa2 || device?.id) {
      newDeviceIds = [device?.id];
    }

    return newDeviceIds;
  }, [isGa2, bundle, device?.id, bundleMembers]);

  const handleDMActionsModalOnClose = useCallback((event) => {
    // Stop event propagation to prevent it from reaching parent BundleOverviewControllerHub component
    event.stopPropagation();
    setIsDMActionsModalOpen(false);
  }, []);

  return (
    <div className={styles.root} onClick={() => setIsDMActionsModalOpen(true)}>
      <div className={styles.title}>Device Commands</div>
      {action ? (
        <div className={styles.activeStatus}>
          <div className={styles.iconCircle}>
            <ActionsIcon className={styles.icon} />
          </div>
          <div className={styles.iconText}>{action?.runtimeStatus}</div>
        </div>
      ) : (
        <div className={styles.inactiveStatus}>None Active</div>
      )}

      {isDMActionsModalOpen && <DMActionsModal onClose={handleDMActionsModalOnClose} allDeviceIds={allDeviceIds} />}
    </div>
  );
};

export default BundleOverviewControllerDMActions;
